export default __webpack_public_path__ + "1b4e8ccebe4f94d4f47efb77c04b1958.png";